import React, { useContext, useEffect, useState } from 'react';
import TitleContext from '../../../TitleContext';
import "../Aboutus/Aboutus.scss";
import Form from './../../../Components/PageHeaderForm/PageHeaderForm';
import EditorForm from './../../../Components/PageContentForm/PageContentForm';
import { getPageHeaderAndContent, updatePageHeaders } from '../../../Apis/pageHeadersApi';
import { updatePageContent } from '../../../Apis/pageContentApi';
import { useLocation } from 'react-router';

export default function PrivacyPolicy() {
    let {changeTitle} = useContext(TitleContext);
    const [pageHeadersId ,setPageHeadersId] = useState({});
    const [pageContentId ,setPageContentId] = useState({});

    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // get privacy page headers and content
    useEffect(()=>{
        changeTitle(`privacy policy`);
        getPageHeaderAndContent('privacy-policy-page').then(res => {
            let mypageHeadersId = res.data.data.headers['privacy-policy-page'].id;
            let mypageContentId = res.data.data.settings['privacy-policy'].id;
            setPageHeadersId(mypageHeadersId);
            setPageContentId(mypageContentId);
        }).catch(err => 
            console.log(err.response)
        )
        // eslint-disable-next-line
    } , []);

    // onsubmit page headers
    const onSubmit = async (e, data) => {
        e.preventDefault();
        data.append("_method", "patch");
        //to send request
        return await updatePageHeaders(pageHeadersId , data).then(res => {
            console.log(res.data.data);
            return "done";          
        }).catch(err =>{
            console.log(err.response);
            return err.response.data.errors;
        })
    };

    // onsubmit page content
    const submitPageContent = async (e, data) =>{
        e.preventDefault();
        return await updatePageContent(pageContentId,{...data , "_method" : "patch"}).then(res=>{
            console.log(res.data.data);
            return "done"; 
        }).catch(err =>{
            console.log(err.response);
            return err.response.data.errors;
        })
    }


    return (
        <>
        <section className='componentGlobalWrapper aboutus'>
            <div className='mb-3'>
                <h5 className='pageSubtitle'>page title</h5>
            </div>
            <Form onSubmit={onSubmit} name={'privacy-policy-page'}/>
        </section>

        <section className='componentGlobalWrapper aboutus'>
            <div className='mb-3'>
                <h5 className='pageSubtitle'>page content</h5>
            </div>
            <EditorForm onSubmit={submitPageContent} name={'privacy-policy-page'} objKey={'privacy-policy'}/>
        </section>
        </>
    )
}
